import * as t from "io-ts";
import { makeMessage } from "./shared.js";
export const themePreProtocol = t.type({
    colors: t.type({
        foreground: t.string,
        background: t.string,
        accent: t.string
    })
});
const state = t.record(t.string, t.unknown);
const setState = makeMessage("set-state", t.type({ state }));
const setTheme = makeMessage("set-theme", t.type({ theme: themePreProtocol }));
const startComponent = makeMessage("start-component");
export const triggerAction = makeMessage("trigger-action", t.type({
    state: t.string
}));
export const preProtocolOutgoingMessages = t.union([setState, setTheme]);
export const preProtocolIncomingMessages = t.union([
    startComponent,
    setState,
    triggerAction
]);
export const PRE_PROTOCOL = {
    outgoing: preProtocolOutgoingMessages,
    incoming: preProtocolIncomingMessages
};
